/**
 * Do not edit directly, this file was auto-generated.
 *
 * Tokens for dark theme
 */

var darkThemeTokens = {
  border: {
    radius: {
      round: "999px",
      large: "8px",
      medium: "6px",
      small: "4px",
      square: "0px"
    },
    color: {
      focus: {
        default: "rgba(71, 174, 246, 1)",
        inverted: "rgba(13, 17, 23, 1)"
      },
      subtle: {
        default: "rgba(69, 74, 79, 1)",
        hover: "rgba(103, 107, 111, 1)",
        active: "rgba(138, 141, 143, 1)",
        unavailable: "rgba(255, 255, 255, 0)"
      },
      medium: {
        default: "rgba(103, 107, 111, 1)",
        hover: "rgba(138, 141, 143, 1)",
        active: "rgba(170, 171, 172, 1)",
        unavailable: "rgba(69, 74, 79, 1)"
      },
      bold: {
        default: "rgba(215, 215, 214, 1)",
        hover: "rgba(231, 230, 228, 1)",
        active: "rgba(245, 243, 239, 1)",
        unavailable: "rgba(255, 255, 255, 0)"
      }
    },
    subtle: {
      default: "1px solid rgba(69, 74, 79, 1)",
      hover: "1px solid rgba(103, 107, 111, 1)",
      active: "1px solid rgba(138, 141, 143, 1)",
      unavailable: "1px solid rgba(255, 255, 255, 0)"
    },
    medium: {
      default: "1px solid rgba(103, 107, 111, 1)",
      hover: "1px solid rgba(138, 141, 143, 1)",
      active: "1px solid rgba(170, 171, 172, 1)",
      unavailable: "1px solid rgba(69, 74, 79, 1)"
    },
    bold: {
      default: "1px solid rgba(215, 215, 214, 1)",
      hover: "1px solid rgba(231, 230, 228, 1)",
      active: "1px solid rgba(245, 243, 239, 1)",
      unavailable: "1px solid rgba(255, 255, 255, 0)"
    },
    focus: {
      default: "2px solid rgba(71, 174, 246, 1)",
      inverted: "2px solid rgba(13, 17, 23, 1)"
    },
    focusOffset: "2px"
  },
  elevation: {
    shadow: {
      bottomSheet: "0px -24px 48px -12px rgba(255, 255, 255, 0)",
      card: "0px 0 4px -1px rgba(255, 255, 255, 0)",
      modal: "0px 24px 48px -12px rgba(255, 255, 255, 0)",
      overlay: "0px 4px 8px -2px rgba(255, 255, 255, 0)",
      panel: "0px 8px 16px -5px rgba(255, 255, 255, 0)"
    },
    borderColor: {
      subtle: "rgba(69, 74, 79, 1)",
      medium: "rgba(103, 107, 111, 1)"
    }
  },
  font: {
    weight: {
      regular: 400,
      bold: 700
    },
    display: {
      base: {
        default: "700 1.25rem/1.5rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif",
        mobile: "700 1.25rem/1.5rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
      },
      large: {
        default: "700 1.75rem/2rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif",
        mobile: "700 1.5rem/1.75rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
      },
      medium: {
        default: "700 1.5rem/1.75rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif",
        mobile: "700 1.5rem/1.75rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
      },
      small: {
        default: "700 1.125rem/1.5rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif",
        mobile: "700 1.125rem/1.5rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
      },
      xlarge: {
        default: "700 2rem/2.5rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif",
        mobile: "700 1.75rem/2rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
      },
      xxlarge: {
        default: "700 2.5rem/3rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif",
        mobile: "700 1.75rem/2rem 'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
      }
    },
    mono: {
      base: {
        default: "400 0.875rem/1.25rem 'Amazon Ember Mono', monospace",
        mobile: "400 1rem/1.5rem 'Amazon Ember Mono', monospace"
      },
      medium: {
        default: "400 1rem/1.5rem 'Amazon Ember Mono', monospace",
        mobile: "400 1.25rem/1.75rem 'Amazon Ember Mono', monospace"
      },
      small: {
        default: "400 0.75rem/1.125rem 'Amazon Ember Mono', monospace",
        mobile: "400 0.875rem/1.25rem 'Amazon Ember Mono', monospace"
      }
    },
    text: {
      base: {
        default: "400 0.875rem/1.25rem 'Amazon Ember', Helvetica, sans-serif",
        mobile: "400 1rem/1.5rem 'Amazon Ember', Helvetica, sans-serif"
      },
      large: {
        default: "400 1.125rem/1.75rem 'Amazon Ember', Helvetica, sans-serif",
        mobile: "400 1.375rem/2rem 'Amazon Ember', Helvetica, sans-serif"
      },
      medium: {
        default: "400 1rem/1.5rem 'Amazon Ember', Helvetica, sans-serif",
        mobile: "400 1.25rem/1.75rem 'Amazon Ember', Helvetica, sans-serif"
      },
      small: {
        default: "400 0.8125rem/1.125rem 'Amazon Ember', Helvetica, sans-serif",
        mobile: "400 0.875rem/1.25rem 'Amazon Ember', Helvetica, sans-serif"
      },
      xlarge: {
        default: "400 1.25rem/2rem 'Amazon Ember', Helvetica, sans-serif",
        mobile: "400 1.5rem/2rem 'Amazon Ember', Helvetica, sans-serif"
      },
      xsmall: {
        default: "400 0.75rem/1.125rem 'Amazon Ember', Helvetica, sans-serif",
        mobile: "400 0.875rem/1.25rem 'Amazon Ember', Helvetica, sans-serif"
      }
    },
    lineHeight: {
      display: {
        xxlarge: {
          default: "3rem",
          mobile: "2rem"
        },
        xlarge: {
          default: "2.5rem",
          mobile: "2rem"
        },
        large: {
          default: "2rem",
          mobile: "1.75rem"
        },
        medium: {
          default: "1.75rem",
          mobile: "1.75rem"
        },
        base: {
          default: "1.5rem",
          mobile: "1.5rem"
        },
        small: {
          default: "1.5rem",
          mobile: "1.5rem"
        }
      },
      text: {
        xlarge: {
          default: "2rem",
          mobile: "2rem"
        },
        large: {
          default: "1.75rem",
          mobile: "2rem"
        },
        medium: {
          default: "1.5rem",
          mobile: "1.75rem"
        },
        base: {
          default: "1.25rem",
          mobile: "1.5rem"
        },
        small: {
          default: "1.125rem",
          mobile: "1.25rem"
        },
        xsmall: {
          default: "1.125rem",
          mobile: "1.25rem"
        }
      },
      mono: {
        medium: {
          default: "1.5rem",
          mobile: "1.75rem"
        },
        base: {
          default: "1.25rem",
          mobile: "1.5rem"
        },
        small: {
          default: "1.125rem",
          mobile: "1.25rem"
        }
      }
    }
  },
  spacing: {
    none: {
      default: "0rem",
      mobile: "0rem"
    },
    xxxxsmall: {
      default: "0.125rem",
      mobile: "0.25rem"
    },
    xxxsmall: {
      default: "0.25rem",
      mobile: "0.375rem"
    },
    xxsmall: {
      default: "0.5rem",
      mobile: "0.75rem"
    },
    xsmall: {
      default: "0.75rem",
      mobile: "1rem"
    },
    small: {
      default: "1rem",
      mobile: "1.25rem"
    },
    base: {
      default: "1.25rem",
      mobile: "1.5rem"
    },
    medium: {
      default: "1.5rem",
      mobile: "2rem"
    },
    large: {
      default: "2rem",
      mobile: "2rem"
    },
    xlarge: {
      default: "2.5rem",
      mobile: "2.5rem"
    },
    xxlarge: {
      default: "3rem",
      mobile: "3rem"
    },
    xxxlarge: {
      default: "4rem",
      mobile: "3rem"
    }
  },
  bannerAlert: {
    backgroundColor: {
      error: "rgba(120, 32, 17, 1)",
      info: "rgba(21, 67, 101, 1)",
      warning: "rgba(64, 59, 12, 1)"
    }
  },
  button: {
    backgroundColor: {
      primary: {
        default: "rgba(255, 255, 255, 1)",
        hover: "rgba(249, 248, 246, 1)",
        active: "rgba(215, 215, 214, 1)",
        hoverSubdued: "rgba(255, 255, 255, 1)",
        unavailable: "rgba(45, 50, 57, 1)",
        unavailableSubdued: "rgba(45, 50, 57, 1)"
      },
      secondary: {
        default: "rgba(69, 74, 79, 1)",
        hover: "rgba(103, 107, 111, 1)",
        active: "rgba(103, 107, 111, 1)",
        unavailable: "rgba(45, 50, 57, 1)"
      },
      transparent: {
        default: "rgba(255, 255, 255, 0)",
        hover: "rgba(45, 50, 57, 1)",
        active: "rgba(69, 74, 79, 1)",
        unavailable: "rgba(255, 255, 255, 0)"
      },
      defaultAi: {
        default: "rgba(69, 74, 79, 1)",
        hover: "rgba(71, 13, 165, 1)",
        active: "rgba(95, 18, 222, 1)",
        unavailable: "rgba(45, 50, 57, 1)"
      },
      primaryAi: {
        default: "rgba(255, 255, 255, 1)",
        hover: "rgba(221, 203, 251, 1)",
        active: "rgba(203, 175, 248, 1)",
        unavailable: "rgba(45, 50, 57, 1)"
      }
    },
    padding: {
      gap: {
        base: {
          default: "0.5rem",
          mobile: "0.75rem"
        },
        small: "0.375rem"
      },
      block: {
        base: {
          default: "0.375rem",
          mobile: "0.375rem"
        },
        small: {
          default: "0.1875rem",
          mobile: "0.1875rem"
        }
      },
      inline: {
        base: {
          default: "1rem",
          mobile: "1rem"
        },
        small: {
          default: "0.5rem",
          mobile: "0.5rem"
        }
      }
    }
  },
  buttonGroup: {
    borderColor: "rgba(69, 74, 79, 1)",
    backgroundColor: {
      unavailable: {
        unselected: "rgba(255, 255, 255, 0)",
        selected: "rgba(138, 141, 143, 1)"
      }
    },
    innerShadow: "0px 0px 0px 0px rgba(255, 255, 255, 0) inset"
  },
  chatBoxInput: {
    attachment: {
      image: {
        innerShadow: "0px 0px 3px 0px #00000033 inset",
        height: "36px",
        width: "36px"
      },
      padding: {
        inline: "5px",
        block: "5px"
      },
      marginBlock: "10px",
      borderRadius: "4px"
    },
    backgroundColor: {
      drag: "rgba(36, 42, 51, 1)"
    },
    gap: "0.625rem"
  },
  contextualDrawer: {
    backgroundColor: "rgba(13, 17, 23, 1)",
    borderColor: "rgba(69, 74, 79, 1)",
    shadow: "0px 0px 6px 0px #3d341a33"
  },
  dataVisualizationColor: {
    categorical: {
      violet: {
        default: "rgba(132, 66, 240, 1)",
        hover: "rgba(95, 18, 222, 1)",
        active: "rgba(71, 13, 165, 1)",
        desaturated: "rgba(103, 70, 158, 1)"
      },
      cyan: {
        default: "rgba(0, 163, 153, 1)",
        hover: "rgba(0, 128, 120, 1)",
        active: "rgba(0, 128, 120, 1)",
        desaturated: "rgba(44, 110, 106, 1)"
      },
      magenta: {
        default: "rgba(233, 58, 173, 1)",
        hover: "rgba(208, 23, 145, 1)",
        active: "rgba(144, 34, 107, 1)",
        desaturated: "rgba(150, 66, 122, 1)"
      },
      periwinkle: {
        default: "rgba(51, 96, 255, 1)",
        hover: "rgba(0, 56, 255, 1)",
        active: "rgba(0, 39, 178, 1)",
        desaturated: "rgba(63, 84, 161, 1)"
      },
      redOrange: {
        default: "rgba(243, 108, 50, 1)",
        hover: "rgba(241, 82, 14, 1)",
        active: "rgba(193, 66, 11, 1)",
        desaturated: "rgba(140, 84, 60, 1)"
      },
      chartreuse: {
        default: "rgba(93, 167, 3, 1)",
        hover: "rgba(70, 125, 2, 1)",
        active: "rgba(70, 125, 2, 1)",
        desaturated: "rgba(85, 115, 48, 1)"
      },
      unselected: {
        default: "rgba(138, 141, 143, 1)",
        hover: "rgba(170, 171, 172, 1)",
        active: "rgba(215, 215, 214, 1)"
      }
    },
    diverging: {
      primary: {
        "0": "rgba(36, 42, 51, 1)",
        "100": "rgba(0, 128, 120, 1)",
        "200": "rgba(0, 163, 153, 1)",
        "300": "rgba(0, 209, 197, 1)",
        "400": "rgba(36, 255, 242, 1)",
        "500": "rgba(92, 255, 245, 1)",
        "600": "rgba(133, 255, 248, 1)",
        "700": "rgba(163, 255, 249, 1)",
        "800": "rgba(194, 255, 251, 1)",
        "900": "rgba(235, 255, 254, 1)",
        "-900": "rgba(240, 231, 253, 1)",
        "-800": "rgba(221, 203, 251, 1)",
        "-700": "rgba(203, 175, 248, 1)",
        "-600": "rgba(181, 142, 246, 1)",
        "-500": "rgba(156, 104, 243, 1)",
        "-400": "rgba(132, 66, 240, 1)",
        "-300": "rgba(95, 18, 222, 1)",
        "-200": "rgba(71, 13, 165, 1)",
        "-100": "rgba(51, 10, 118, 1)"
      },
      secondary: {
        "0": "rgba(36, 42, 51, 1)",
        "100": "rgba(0, 28, 128, 1)",
        "200": "rgba(0, 39, 178, 1)",
        "300": "rgba(0, 56, 255, 1)",
        "400": "rgba(51, 96, 255, 1)",
        "500": "rgba(93, 129, 255, 1)",
        "600": "rgba(133, 160, 255, 1)",
        "700": "rgba(168, 187, 255, 1)",
        "800": "rgba(199, 211, 255, 1)",
        "900": "rgba(229, 235, 255, 1)",
        "-900": "rgba(254, 241, 236, 1)",
        "-800": "rgba(252, 224, 212, 1)",
        "-700": "rgba(251, 203, 183, 1)",
        "-600": "rgba(249, 175, 144, 1)",
        "-500": "rgba(247, 151, 110, 1)",
        "-400": "rgba(243, 108, 50, 1)",
        "-300": "rgba(241, 82, 14, 1)",
        "-200": "rgba(193, 66, 11, 1)",
        "-100": "rgba(135, 46, 8, 1)"
      }
    },
    sequential: {
      warm: {
        "100": "rgba(143, 54, 143, 1)",
        "200": "rgba(184, 71, 134, 1)",
        "300": "rgba(220, 92, 114, 1)",
        "400": "rgba(247, 118, 89, 1)",
        "500": "rgba(255, 156, 58, 1)",
        "600": "rgba(254, 192, 45, 1)",
        "700": "rgba(244, 228, 63, 1)",
        "800": "rgba(240, 240, 178, 1)",
        "900": "rgba(246, 247, 222, 1)"
      },
      cool: {
        "100": "rgba(0, 97, 162, 1)",
        "200": "rgba(0, 126, 170, 1)",
        "300": "rgba(0, 154, 169, 1)",
        "400": "rgba(0, 181, 161, 1)",
        "500": "rgba(0, 206, 138, 1)",
        "600": "rgba(51, 230, 101, 1)",
        "700": "rgba(137, 245, 4, 1)",
        "800": "rgba(208, 241, 126, 1)",
        "900": "rgba(232, 244, 185, 1)"
      },
      blue: {
        "100": "rgba(63, 63, 144, 1)",
        "200": "rgba(75, 99, 166, 1)",
        "300": "rgba(88, 130, 186, 1)",
        "400": "rgba(104, 159, 201, 1)",
        "500": "rgba(122, 185, 214, 1)",
        "600": "rgba(144, 210, 227, 1)",
        "700": "rgba(168, 233, 239, 1)",
        "800": "rgba(194, 255, 251, 1)",
        "900": "rgba(216, 253, 251, 1)"
      },
      orange: {
        "100": "rgba(217, 84, 42, 1)",
        "200": "rgba(229, 111, 46, 1)",
        "300": "rgba(239, 136, 55, 1)",
        "400": "rgba(245, 161, 70, 1)",
        "500": "rgba(248, 185, 91, 1)",
        "600": "rgba(250, 208, 117, 1)",
        "700": "rgba(252, 228, 144, 1)",
        "800": "rgba(255, 248, 175, 1)",
        "900": "rgba(252, 248, 207, 1)"
      },
      green: {
        "100": "rgba(43, 102, 79, 1)",
        "200": "rgba(73, 127, 99, 1)",
        "300": "rgba(100, 151, 117, 1)",
        "400": "rgba(125, 174, 134, 1)",
        "500": "rgba(151, 195, 149, 1)",
        "600": "rgba(177, 215, 166, 1)",
        "700": "rgba(201, 235, 180, 1)",
        "800": "rgba(227, 254, 195, 1)",
        "900": "rgba(241, 253, 226, 1)"
      }
    }
  },
  datePicker: {
    backgroundColor: {
      default: "rgba(45, 50, 57, 1)",
      hover: "rgba(21, 67, 101, 1)",
      potentialRangeHover: "rgba(29, 96, 143, 1)",
      today: "rgba(103, 107, 111, 1)",
      selected: "rgba(119, 195, 248, 1)",
      selectedRange: "rgba(29, 96, 143, 1)",
      unavailable: "rgba(255, 255, 255, 0)"
    },
    dateGap: "2px",
    dayWidth: {
      default: "30px",
      mobile: "40px"
    }
  },
  dropZone: {
    backgroundColor: {
      default: "rgba(22, 29, 38, 1)",
      hover: "rgba(36, 42, 51, 1)",
      unavailable: "rgba(13, 17, 23, 1)"
    },
    padding: "0.875rem",
    dropZoneTextContainer: {
      marginTop: "0.875rem"
    },
    uploaderAlert: {
      marginTop: "0.375rem"
    }
  },
  icon: {
    color: {
      default: "rgba(245, 243, 239, 1)",
      secondary: "rgba(215, 215, 214, 1)",
      tertiary: "rgba(138, 141, 143, 1)",
      tertiaryHover: "rgba(103, 107, 111, 1)",
      tertiaryActive: "rgba(69, 74, 79, 1)",
      unavailable: "rgba(103, 107, 111, 1)",
      inverted: "rgba(22, 29, 38, 1)",
      invertedHover: "rgba(45, 50, 57, 1)",
      invertedActive: "rgba(69, 74, 79, 1)",
      invertedUnavailable: "rgba(103, 107, 111, 1)"
    },
    size: {
      xsmall: {
        default: "0.65625rem",
        mobile: "0.75rem"
      },
      small: {
        default: "0.765625rem",
        mobile: "0.875rem"
      },
      base: {
        default: "0.875rem",
        mobile: "1rem"
      },
      large: {
        default: "1.09375rem",
        mobile: "1.25rem"
      },
      xlarge: {
        default: "1.53125rem",
        mobile: "1.75rem"
      }
    }
  },
  input: {
    backgroundColor: {
      default: "rgba(36, 42, 51, 1)",
      unavailable: "rgba(45, 50, 57, 1)"
    },
    innerShadow: "0px 1px 3px 0px rgba(255, 255, 255, 0) inset",
    minWidth: "100px",
    maxWidth: "285px"
  },
  link: {
    color: {
      default: "rgba(71, 174, 246, 1)",
      hover: "rgba(119, 195, 248, 1)",
      inverted: "rgba(13, 17, 23, 1)",
      invertedHover: "rgba(45, 50, 57, 1)"
    },
    decoration: {
      default: "none",
      hover: "underline"
    }
  },
  modal: {
    shroudColor: "rgba(0, 0, 0, 0.502)",
    shroudBlur: "3px"
  },
  pieChart: {
    donutPadding: 16,
    color: {
      warm: {
        few: ["rgba(240, 240, 178, 1)", "rgba(244, 228, 63, 1)", "rgba(247, 118, 89, 1)", "rgba(184, 71, 134, 1)", "rgba(143, 54, 143, 1)"],
        many: ["rgba(240, 240, 178, 1)", "rgba(244, 228, 63, 1)", "rgba(254, 192, 45, 1)", "rgba(255, 156, 58, 1)", "rgba(247, 118, 89, 1)", "rgba(220, 92, 114, 1)", "rgba(184, 71, 134, 1)", "rgba(143, 54, 143, 1)", "rgba(246, 247, 222, 1)"]
      },
      cool: {
        few: ["rgba(208, 241, 126, 1)", "rgba(51, 230, 101, 1)", "rgba(0, 181, 161, 1)", "rgba(0, 126, 170, 1)", "rgba(0, 97, 162, 1)"],
        many: ["rgba(208, 241, 126, 1)", "rgba(137, 245, 4, 1)", "rgba(51, 230, 101, 1)", "rgba(0, 206, 138, 1)", "rgba(0, 181, 161, 1)", "rgba(0, 154, 169, 1)", "rgba(0, 126, 170, 1)", "rgba(0, 97, 162, 1)", "rgba(232, 244, 185, 1)"]
      },
      blue: {
        few: ["rgba(63, 63, 144, 1)", "rgba(88, 130, 186, 1)", "rgba(122, 185, 214, 1)"],
        several: ["rgba(75, 99, 166, 1)", "rgba(88, 130, 186, 1)", "rgba(104, 159, 201, 1)", "rgba(194, 255, 251, 1)", "rgba(216, 253, 251, 1)"],
        many: ["rgba(63, 63, 144, 1)", "rgba(75, 99, 166, 1)", "rgba(88, 130, 186, 1)", "rgba(104, 159, 201, 1)", "rgba(122, 185, 214, 1)", "rgba(144, 210, 227, 1)", "rgba(168, 233, 239, 1)", "rgba(194, 255, 251, 1)", "rgba(51, 10, 118, 1)"]
      },
      green: {
        few: ["rgba(43, 102, 79, 1)", "rgba(100, 151, 117, 1)", "rgba(151, 195, 149, 1)"],
        several: ["rgba(43, 102, 79, 1)", "rgba(73, 127, 99, 1)", "rgba(125, 174, 134, 1)", "rgba(177, 215, 166, 1)", "rgba(227, 254, 195, 1)"],
        many: ["rgba(43, 102, 79, 1)", "rgba(73, 127, 99, 1)", "rgba(100, 151, 117, 1)", "rgba(125, 174, 134, 1)", "rgba(151, 195, 149, 1)", "rgba(177, 215, 166, 1)", "rgba(201, 235, 180, 1)", "rgba(227, 254, 195, 1)", "rgba(0, 74, 57, 1)"]
      },
      orange: {
        few: ["rgba(217, 84, 42, 1)", "rgba(239, 136, 55, 1)", "rgba(248, 185, 91, 1)"],
        several: ["rgba(217, 84, 42, 1)", "rgba(229, 111, 46, 1)", "rgba(245, 161, 70, 1)", "rgba(250, 208, 117, 1)", "rgba(255, 248, 175, 1)"],
        many: ["rgba(217, 84, 42, 1)", "rgba(229, 111, 46, 1)", "rgba(239, 136, 55, 1)", "rgba(245, 161, 70, 1)", "rgba(248, 185, 91, 1)", "rgba(250, 208, 117, 1)", "rgba(252, 228, 144, 1)", "rgba(255, 248, 175, 1)", "rgba(201, 55, 44, 1)"]
      },
      background: "rgba(22, 29, 38, 1)"
    }
  },
  pageBanner: {
    image: {
      backgroundColor: "rgba(13, 17, 23, 1)",
      borderColor: "rgba(231, 230, 228, 1)",
      borderRadius: "6px",
      padding: "0.625rem"
    },
    paddingInline: {
      default: "2rem",
      mobile: "1rem"
    },
    paddingBlock: {
      default: "1rem",
      mobile: "0.75rem"
    },
    gap: {
      default: "1.5rem",
      mobile: "2rem"
    },
    borderRadius: "8px"
  },
  pageHeader: {
    backgroundColor: "rgba(45, 50, 57, 1)",
    boxShadow: "0px 2px 3px -1px rgba(52, 26, 51, 0.24)"
  },
  progressIndicator: {
    trackColor: "rgba(69, 74, 79, 1)",
    valueColor: {
      default: {
        "100": "rgba(203, 175, 248, 1)",
        "200": "rgba(156, 104, 243, 1)",
        "300": "rgba(132, 66, 240, 1)"
      },
      error: {
        "100": "rgba(247, 66, 34, 1)",
        "200": "rgba(169, 45, 23, 1)",
        "300": "rgba(120, 32, 17, 1)"
      },
      warning: {
        "100": "rgba(247, 151, 110, 1)",
        "200": "rgba(208, 106, 38, 1)",
        "300": "rgba(171, 87, 31, 1)"
      }
    },
    widthTransition: "width .2s ease-in",
    spacing: {
      inline: "4px"
    },
    trackHeight: {
      large: "10px",
      base: "6px"
    },
    tick: {
      width: "1px",
      height: "14px",
      paddingInline: "1px"
    },
    borderRadius: "0px"
  },
  rangeSlider: {
    trackColor: "rgba(69, 74, 79, 1)",
    handleColor: "rgba(231, 230, 228, 1)",
    trackHeight: {
      default: "4px",
      mobile: "6px"
    },
    handleDiameter: {
      default: "18px",
      mobile: "26px"
    }
  },
  selectableWidget: {
    shape: {
      backgroundColor: {
        inverted: "rgba(138, 141, 143, 1)",
        default: "rgba(22, 29, 38, 1)"
      }
    },
    backgroundColor: {
      default: "rgba(22, 29, 38, 1)",
      defaultInverted: "rgba(138, 141, 143, 1)",
      hover: "rgba(35, 115, 172, 1)",
      active: "rgba(71, 174, 246, 1)",
      selected: "rgba(43, 140, 209, 1)",
      unavailable: "rgba(45, 50, 57, 1)",
      unavailableSelected: "rgba(138, 141, 143, 1)",
      unavailableInverted: "rgba(45, 50, 57, 1)"
    },
    controlLabelGap: {
      default: "0.375rem",
      mobile: "0.5rem"
    }
  },
  selectableContainer: {
    borderColor: {
      default: "rgba(69, 74, 79, 1)",
      hover: "rgba(103, 107, 111, 1)",
      selected: "rgba(170, 171, 172, 1)",
      selectedHover: "rgba(215, 215, 214, 1)"
    },
    backgroundColor: {
      default: "rgba(22, 29, 38, 1)",
      hover: "rgba(45, 50, 57, 1)",
      selected: "rgba(69, 74, 79, 1)"
    },
    borderRadius: "8px",
    borderWidth: {
      default: "1px",
      selected: "2px"
    },
    border: {
      default: "1px solid rgba(69, 74, 79, 1)",
      hover: "1px solid rgba(103, 107, 111, 1)",
      selected: "2px solid rgba(170, 171, 172, 1)",
      selectedHover: "2px solid rgba(215, 215, 214, 1)"
    }
  },
  selectListItem: {
    selectedHighlight: {
      backgroundColor: "rgba(71, 174, 246, 1)",
      width: "4px",
      height: "24px",
      borderRadius: "4px",
      insetInlineStart: "4px",
      insetBlockStart: "4px",
      insetBlockEnd: "4px"
    }
  },
  seriesChart: {
    backgroundColor: "rgba(13, 17, 23, 1)",
    area: {
      opacity: 30
    },
    categoricalBreakdownColor: {
      violet: ["rgba(95, 18, 222, 1)", "rgba(132, 66, 240, 1)", "rgba(156, 104, 243, 1)", "rgba(203, 175, 248, 1)", "rgba(221, 203, 251, 1)"],
      cyan: ["rgba(0, 128, 120, 1)", "rgba(0, 209, 197, 1)", "rgba(36, 255, 242, 1)", "rgba(133, 255, 248, 1)", "rgba(194, 255, 251, 1)"],
      magenta: ["rgba(144, 34, 107, 1)", "rgba(233, 58, 173, 1)", "rgba(239, 108, 194, 1)", "rgba(243, 145, 209, 1)", "rgba(250, 214, 238, 1)"],
      periwinkle: ["rgba(0, 56, 255, 1)", "rgba(51, 96, 255, 1)", "rgba(93, 129, 255, 1)", "rgba(168, 187, 255, 1)", "rgba(199, 211, 255, 1)"],
      redOrange: ["rgba(193, 66, 11, 1)", "rgba(241, 82, 14, 1)", "rgba(247, 151, 110, 1)", "rgba(251, 203, 183, 1)", "rgba(252, 224, 212, 1)"],
      chartreuse: ["rgba(93, 167, 3, 1)", "rgba(114, 205, 4, 1)", "rgba(137, 245, 4, 1)", "rgba(167, 252, 65, 1)", "rgba(190, 252, 115, 1)", "rgba(213, 253, 165, 1)"]
    },
    yAxisLines: {
      color: "rgba(69, 74, 79, 1)",
      borderWidth: "1px",
      originBorderWidth: "2px"
    },
    yAxisLabels: {
      violet: "rgba(156, 104, 243, 1)",
      cyan: "rgba(0, 163, 153, 1)",
      magenta: "rgba(233, 58, 173, 1)",
      periwinkle: "rgba(93, 129, 255, 1)",
      redOrange: "rgba(241, 82, 14, 1)",
      chartreuse: "rgba(93, 167, 3, 1)"
    },
    hoverIndicators: {
      dot: {
        background: "rgba(13, 17, 23, 1)",
        circumference: "8px"
      },
      line: {
        borderColor: "rgba(249, 248, 246, 1)",
        borderWidth: "2px"
      }
    },
    categoricalBreakdownBorder: {
      color: "rgba(13, 17, 23, 1)"
    },
    chartControls: {
      swatchWidth: "22px",
      swatchHeight: "22px",
      minWidth: "140px",
      maxWidth: "300px"
    },
    popoverMetrics: {
      minWidth: "220px",
      shape: {
        maxWidth: "16px",
        circleDiameter: "13px",
        triangleWidth: "15px",
        triangleRadius: "1px",
        squareBorderRadius: "2px",
        squareWidthHeight: "12px"
      }
    }
  },
  sheet: {
    externalIcon: {
      color: {
        default: "rgba(245, 243, 239, 1)",
        hover: "rgba(231, 230, 228, 1)"
      },
      outlineColor: "rgba(245, 243, 239, 1)"
    },
    shroudColor: "rgba(0, 0, 0, 0.5)",
    shroudBlur: "3px"
  },
  summaryCardExpanded: {
    shroud: {
      backgroundColor: "#00000099"
    },
    borderRadius: "8px",
    margin: "1.5rem"
  },
  summaryCardRow: {
    scrollButton: {
      backgroundColor: {
        hover: "rgba(103, 107, 111, 1)",
        default: "rgba(69, 74, 79, 1)",
        active: "rgba(103, 107, 111, 1)"
      },
      offsetInline: "1.25rem",
      height: "80px"
    },
    card: {
      minWidth: "360px"
    }
  },
  steps: {
    iconColor: {
      unavailable: "rgba(138, 141, 143, 1)",
      active: "rgba(67, 213, 101, 1)",
      future: "rgba(215, 215, 214, 1)"
    },
    iconDiameter: "1.125rem",
    spacing: {
      labelGap: "0.375rem"
    }
  },
  starRating: {
    borderColor: {
      amazonui: "rgba(222, 121, 33, 1)",
      ink: "rgba(249, 248, 246, 1)"
    },
    fillColor: {
      amazonui: "rgba(222, 121, 33, 1)",
      ink: "rgba(249, 248, 246, 1)"
    },
    emptyColor: "rgba(13, 17, 23, 1)"
  },
  support: {
    backgroundColor: {
      info: "rgba(14, 48, 74, 1)",
      error: "rgba(92, 26, 16, 1)",
      success: "rgba(11, 61, 23, 1)",
      warning: "rgba(64, 59, 12, 1)",
      spotlightBold: "rgba(165, 154, 250, 1)",
      spotlight: "rgba(41, 36, 87, 1)",
      featureIntroduction: "rgba(0, 125, 97, 1)"
    },
    border: {
      error: "1px solid rgba(247, 66, 34, 1)",
      info: "1px solid rgba(150, 189, 244, 1)",
      spotlight: "1px solid rgba(187, 179, 251, 1)",
      success: "1px solid rgba(67, 213, 101, 1)",
      warning: "1px solid rgba(255, 197, 158, 1)",
      ai: "1px solid rgba(156, 104, 243, 1)"
    },
    borderColor: {
      info: "rgba(150, 189, 244, 1)",
      error: "rgba(247, 66, 34, 1)",
      success: "rgba(67, 213, 101, 1)",
      warning: "rgba(255, 197, 158, 1)",
      spotlight: "rgba(187, 179, 251, 1)",
      ai: "rgba(156, 104, 243, 1)",
      subtle: {
        info: "rgba(21, 67, 101, 1)",
        error: "rgba(120, 32, 17, 1)",
        success: "rgba(15, 74, 29, 1)",
        warning: "rgba(84, 77, 7, 1)",
        default: "rgba(45, 50, 57, 1)"
      }
    },
    iconColor: {
      info: "rgba(150, 189, 244, 1)",
      error: "rgba(250, 133, 112, 1)",
      success: "rgba(67, 213, 101, 1)",
      warning: "rgba(255, 197, 158, 1)",
      spotlight: "rgba(208, 203, 252, 1)",
      opportunity: "rgba(234, 188, 62, 1)",
      ai: "rgba(95, 18, 222, 1)"
    },
    textColor: {
      info: "rgba(185, 211, 248, 1)",
      error: "rgba(251, 165, 149, 1)",
      success: "rgba(67, 213, 101, 1)",
      warning: "rgba(255, 218, 194, 1)",
      spotlight: "rgba(208, 203, 252, 1)",
      ai: "rgba(95, 18, 222, 1)"
    }
  },
  surface: {
    default: "rgba(13, 17, 23, 1)",
    subtleOffset: "rgba(22, 29, 38, 1)",
    offset: "rgba(36, 42, 51, 1)",
    inverted: "rgba(255, 255, 255, 1)",
    container: {
      default: "rgba(22, 29, 38, 1)",
      hover: "rgba(36, 42, 51, 1)",
      selected: "rgba(45, 50, 57, 1)",
      active: "rgba(69, 74, 79, 1)",
      unavailable: "rgba(13, 17, 23, 1)",
      offset: {
        default: "rgba(45, 50, 57, 1)",
        hover: "rgba(69, 74, 79, 1)",
        selected: "rgba(45, 50, 57, 1)",
        active: "rgba(36, 42, 51, 1)",
        unavailable: "rgba(22, 29, 38, 1)",
        inverted: "rgba(255, 255, 255, 1)"
      }
    }
  },
  table: {
    cell: {
      editableIndicator: {
        backgroundColor: "rgba(138, 141, 143, 1)"
      },
      borderColor: {
        body: {
          default: "rgba(45, 50, 57, 1)",
          hover: "rgba(69, 74, 79, 1)",
          active: "rgba(69, 74, 79, 1)"
        },
        header: {
          default: "rgba(103, 107, 111, 1)",
          hover: "rgba(69, 74, 79, 1)",
          active: "rgba(69, 74, 79, 1)"
        },
        footer: {
          default: "rgba(69, 74, 79, 1)",
          hover: "rgba(103, 107, 111, 1)",
          active: "rgba(103, 107, 111, 1)"
        }
      },
      backgroundColor: {
        body: {
          default: "rgba(255, 255, 255, 0)",
          hover: "rgba(245, 243, 239, 1)",
          active: "rgba(255, 255, 255, 1)"
        },
        header: {
          default: "rgba(255, 255, 255, 0)",
          hover: "rgba(245, 243, 239, 1)",
          active: "rgba(255, 255, 255, 1)"
        },
        footer: {
          default: "rgba(255, 255, 255, 0)",
          hover: "rgba(245, 243, 239, 1)",
          active: "rgba(255, 255, 255, 1)"
        }
      },
      border: {
        body: {
          default: "1px solid rgba(45, 50, 57, 1)",
          hover: "1px solid rgba(69, 74, 79, 1)",
          active: "1px solid rgba(69, 74, 79, 1)"
        },
        header: {
          default: "1px solid rgba(103, 107, 111, 1)",
          hover: "1px solid rgba(69, 74, 79, 1)",
          active: "1px solid rgba(69, 74, 79, 1)"
        }
      },
      padding: {
        inline: "0.5rem",
        block: "0.3125rem"
      }
    },
    row: {
      backgroundColor: {
        hover: "rgba(22, 29, 38, 1)"
      }
    }
  },
  tabbedNavigation: {
    text: {
      color: {
        active: "rgba(249, 248, 246, 1)",
        hover: "rgba(231, 230, 228, 1)",
        unavailable: "rgba(170, 171, 172, 1)"
      }
    },
    highlight: {
      color: "rgba(35, 115, 172, 1)",
      radius: "2px 2px 0 0",
      height: "3px"
    },
    scrollIndicatorWidth: "60px"
  },
  tag: {
    backgroundColor: {
      default: "rgba(69, 74, 79, 1)",
      beta: "rgba(103, 107, 111, 1)",
      error: "rgba(120, 32, 17, 1)",
      info: "rgba(0, 59, 143, 1)",
      warning: "rgba(119, 111, 31, 1)",
      success: "rgba(21, 105, 41, 1)",
      new: "rgba(88, 78, 171, 1)",
      violet: "rgba(71, 13, 165, 1)",
      cyan: "rgba(0, 128, 120, 1)",
      magenta: "rgba(144, 34, 107, 1)",
      periwinkle: "rgba(0, 39, 178, 1)",
      redOrange: "rgba(193, 66, 11, 1)",
      chartreuse: "rgba(70, 125, 2, 1)"
    }
  },
  text: {
    color: {
      default: "rgba(249, 248, 246, 1)",
      secondary: "rgba(231, 230, 228, 1)",
      tertiary: "rgba(215, 215, 214, 1)",
      unavailable: "rgba(170, 171, 172, 1)",
      unavailableInverted: "rgba(103, 107, 111, 1)",
      inverted: "rgba(13, 17, 23, 1)"
    },
    marginBlockStart: {
      default: "1em",
      mobile: "1em"
    },
    marginBlockEnd: {
      default: "0.5em",
      mobile: "0.5em"
    }
  },
  controls: {
    blockLabelGapSm: {
      default: "0.125rem",
      mobile: "0.375rem"
    },
    blockLabelGapLg: {
      default: "0.375rem",
      mobile: "0.5rem"
    },
    headerGap: {
      default: "0.25rem",
      mobile: "0.375rem"
    },
    labelGap: {
      default: "0.5rem",
      mobile: "0.5rem"
    },
    letterGap: {
      default: "0.1875rem",
      mobile: "0.25rem"
    },
    height: {
      base: {
        default: "2rem",
        mobile: "2.75rem"
      },
      small: {
        default: "1.5rem",
        mobile: "2.25rem"
      },
      xsmall: {
        default: "1rem",
        mobile: "1.5rem"
      }
    },
    paddingBlock: {
      xsmall: {
        default: "0.0625rem",
        mobile: "0.125rem"
      },
      small: {
        default: "0.125rem",
        mobile: "0.4375rem"
      },
      base2pxBorder: {
        default: "0.25rem",
        mobile: "0.5rem"
      },
      base: {
        default: "0.3125rem",
        mobile: "0.5625rem"
      },
      iconBase: {
        default: "0.5rem",
        mobile: "0.8125rem"
      },
      iconSmall: {
        default: "0.3125rem",
        mobile: "0.625rem"
      }
    },
    paddingInline: {
      xsmall: {
        default: "0.125rem",
        mobile: "0.25rem"
      },
      small: {
        default: "0.1875rem",
        mobile: "0.375rem"
      },
      base: {
        default: "0.375rem",
        mobile: "0.5rem"
      },
      medium: {
        default: "0.5rem",
        mobile: "0.625rem"
      },
      large: {
        default: "0.625rem",
        mobile: "0.625rem"
      },
      xlarge: {
        default: "1rem",
        mobile: "0.75rem"
      },
      xxlarge: {
        default: "1.25rem",
        mobile: "1rem"
      },
      xxxlarge: {
        default: "2rem",
        mobile: "1.5rem"
      }
    }
  },
  anchoredAlert: {
    zIndex: "100"
  },
  cardListItem: {
    content: {
      marginBlockStart: "0.625rem",
      marginInlineEnd: "0.625rem",
      dataLabel: {
        marginInlineEnd: "0.3125rem"
      },
      dataValue: {
        marginInlineStart: "0.125rem"
      }
    },
    image: {
      minWidth: "3.125rem",
      maxWidth: "3.125rem"
    }
  },
  checkboxGroup: {
    minWidth: {
      mobile: "200px"
    }
  },
  circularProgressIndicator: {
    size: {
      small: "100px",
      base: "125px"
    }
  },
  countryList: {
    secondaryView: {
      footer: {
        height: "84px"
      }
    }
  },
  dateRangePicker: {
    presetSelector: {
      minWidth: "150px"
    }
  },
  dropdown: {
    popover: {
      maxHeight: "400px",
      offsetScrollbar: "0.25rem",
      offsetDistance: 2
    }
  },
  fileUploadButton: {
    criteriaListContainer: {
      marginTop: {
        default: "0.375rem"
      }
    }
  },
  form: {
    maxWidth: "1023px"
  },
  heading: {
    marginBlockStart: {
      default: "2rem",
      mobile: "2rem"
    },
    marginBlockEnd: {
      default: "0.75rem",
      mobile: "0.75rem"
    }
  },
  list: {
    marginInlineStart: "1.5em"
  },
  focusPageHeader: {
    closeIconMargin: {
      default: "0.375rem",
      mobile: "0.375rem"
    }
  },
  radioButton: {
    width: "16px",
    height: "16px",
    dot: {
      width: "6px",
      height: "6px"
    }
  },
  sectionExpander: {
    transition: "background-color 100ms ease"
  },
  sideNavigation: {
    width: "11.5rem"
  },
  snackbar: {
    maxWidth: {
      default: "28.125rem",
      mobile: "100%"
    }
  },
  summaryCard: {
    minWidth: "360px",
    gap: "0.875rem",
    header: {
      content: {
        paddingBlockEnd: "0.125rem"
      }
    },
    backgroundColor: {
      default: "rgba(22, 29, 38, 1)",
      offset: "rgba(45, 50, 57, 1)"
    },
    disabled: {
      opacity: "0.6"
    }
  },
  switch: {
    circleDiameter: {
      base: {
        default: "14px",
        mobile: "20px"
      },
      small: {
        default: "12px",
        mobile: "14px"
      }
    },
    iconDiameter: {
      base: {
        default: "14px",
        mobile: "18px"
      },
      small: {
        default: "12px",
        mobile: "14px"
      }
    },
    padding: {
      base: {
        default: "5px",
        mobile: "8px"
      },
      small: {
        default: "4px",
        mobile: "5px"
      }
    },
    slideTransition: "100ms",
    slideTransitionX: {
      base: {
        default: "22px",
        mobile: "28px"
      },
      small: {
        default: "20px",
        mobile: "24px"
      }
    },
    trackHeight: {
      base: {
        default: "24px",
        mobile: "36px"
      },
      small: {
        default: "20px",
        mobile: "24px"
      }
    },
    trackWidth: {
      base: {
        default: "46px",
        mobile: "64px"
      },
      small: {
        default: "40px",
        mobile: "48px"
      }
    }
  },
  textarea: {
    maxWidth: {
      default: "285px",
      mobile: "inherit"
    },
    minWidth: "237px"
  },
  tooltip: {
    maxWidth: "25rem",
    maxHeight: "25rem"
  }
};

export { darkThemeTokens as d };
//# sourceMappingURL=dark-C1oK4iVK-C1oK4iVK.js.map
